var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreasuryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon=credit-card-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8337 8.33317H2.16699M2.16699 6.83317L2.16699 13.1665C2.16699 14.0999 2.16699 14.5666 2.34865 14.9232C2.50844 15.2368 2.7634 15.4917 3.07701 15.6515C3.43353 15.8332 3.90024 15.8332 4.83366 15.8332L16.167 15.8332C17.1004 15.8332 17.5671 15.8332 17.9236 15.6515C18.2372 15.4917 18.4922 15.2368 18.652 14.9232C18.8337 14.5666 18.8337 14.0999 18.8337 13.1665V6.83317C18.8337 5.89975 18.8337 5.43304 18.652 5.07652C18.4922 4.76292 18.2372 4.50795 17.9236 4.34816C17.5671 4.16651 17.1004 4.16651 16.167 4.1665L4.83366 4.1665C3.90024 4.1665 3.43353 4.1665 3.07701 4.34816C2.7634 4.50795 2.50844 4.76292 2.34865 5.07652C2.16699 5.43304 2.16699 5.89975 2.16699 6.83317Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasuryIcon);
export default __webpack_public_path__ + "static/media/TreasuryIcon.78fb7f3ee660e742d59f5c5730da5581.svg";
export { ForwardRef as ReactComponent };